import { EntityDefinition } from '@/types/crud';

export const companyEntity: EntityDefinition = {
  name: 'companies',
  displayName: 'Companies',
  displayNameSingular: 'Company',
  apiEndpoint: '/generic/crm_companies',
  idField: 'id',
  nameField: 'name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
key: 'name',
      label: 'crm.companies.companyName',
      type: 'text',
      required: true,
      placeholder: 'Enter company name',
      order: 1
    },
    {
key: 'industry',
      label: 'crm.companies.industry',
      type: 'text',
      placeholder: 'Enter industry',
      order: 2
    },
    {
key: 'sector',
      label: 'crm.companies.sector',
      type: 'text',
      placeholder: 'Enter sector',
      order: 3
    },
    {
key: 'size_category',
      label: 'crm.companies.companySize',
      type: 'select',
      options: [
{ value: '0-10', label: '0-10' },
        { value: '11-100', label: '11-100' },
        { value: '101-1000', label: '101-1000' },
        { value: '1001-10000', label: '1001-10000' },
        { value: '10001-50000', label: '10001-50000' },
        { value: '50000+', label: '50000+' }
      ],
      order: 4
    },
    {
key: 'revenue_range',
      label: 'crm.companies.revenueRange',
      type: 'select',
      options: [
{ value: 'under_1m', label: 'crm.companies.revenueRanges.under1m' },
        { value: '1m_10m', label: 'crm.companies.revenueRanges.1m10m' },
        { value: '10m_50m', label: 'crm.companies.revenueRanges.10m50m' },
        { value: '50m_100m', label: 'crm.companies.revenueRanges.50m100m' },
        { value: 'over_100m', label: 'crm.companies.revenueRanges.over100m' }
      ],
      order: 5
    },
    {
key: 'employee_count',
      label: 'crm.companies.employeeCount',
      type: 'number',
      placeholder: 'Enter employee count',
      order: 6
    },
    {
key: 'headquarters_location',
      label: 'crm.companies.headquartersLocation',
      type: 'text',
      placeholder: 'Enter headquarters location',
      order: 7
    },
    {
key: 'website',
      label: 'crm.companies.website',
      type: 'url',
      placeholder: 'Enter website URL',
      order: 8
    },
    {
key: 'description',
      label: 'crm.companies.description',
      type: 'textarea',
      placeholder: 'Enter company description',
      order: 9
    },
    {
key: 'pe_owner_id',
      label: 'crm.companies.peOwnerId',
      type: 'text',
      placeholder: 'Enter PE owner ID',
      order: 10
    },
    {
key: 'pe_owner_name',
      label: 'crm.companies.peOwnerName',
      type: 'text',
      placeholder: 'Enter PE owner name',
      order: 11
    },
    {
key: 'acquisition_date',
      label: 'crm.companies.acquisitionDate',
      type: 'date',
      order: 12
    },
    {
key: 'acquisition_value',
      label: 'crm.companies.acquisitionValue',
      type: 'number',
      placeholder: 'Enter acquisition value',
      order: 13
    },
    {
key: 'status',
      label: 'Status',
      type: 'select',
      required: true,
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'do_not_contact', label: 'Do Not Contact' },
        { value: 'prospect', label: 'Prospect' }
      ],
      defaultValue: 'active',
      order: 14
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 15
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      hidden: true,
      order: 16
    }
  ],
  tableColumns: [
    {
      key: 'name',
      label: 'Company Name',
      sortable: true
    },
    {
      key: 'industry',
      label: 'Industry',
      sortable: true
    },
    {
      key: 'sector',
      label: 'Sector',
      sortable: true
    },
    {
      key: 'size_category',
      label: 'Size',
      sortable: true
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      colorCoding: {
        'active': 'text-green-600 font-medium'
      }
    },
    {
      key: 'headquarters_location',
      label: 'Headquarters',
      sortable: true
    },
    {
      key: 'employee_count',
      label: 'Employees',
      sortable: true
    },
    {
      key: 'acquisition_date',
      label: 'Acquisition Date',
      sortable: true
    }
  ],
  searchFields: ['name', 'industry', 'sector', 'headquarters_location'],
  defaultSort: { field: 'name', direction: 'asc' }
};
